import moment from 'moment';
import { Suffix_List } from './constants';

const timeTypeList = [
    {
        type: 'date',
        basic_index: 0,
    },
    {
        type: 'week',
        basic_index: 2,
    },
    {
        type: 'month',
        basic_index: 4,
    }
];

const getSuffixIndexByTime = (timeType, time) => {
    return timeTypeList.reduce((pV, cItem) => {
        if (pV !== null) {
            return pV;
        };
        const { type, basic_index } = cItem;
        if (timeType === type) {
            // time 是否是moment偏移量，暂无检查
            return basic_index + (moment(time).isSame(moment(), type) ? 0 : 1);
        };
        return pV;
    }, null);
};

const getSuffix = (position, timeType, time) => {
    const index = getSuffixIndexByTime(timeType, time);
    if (index === null) { return '' };
    let suffix = '';
    try {
        suffix = Suffix_List[position][index]
    } catch (err) { };
    return suffix;
};

export {
    getSuffix,
};
